import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
/**
 * fetch all Members entries
 */
export const fetchMembersItems = createAsyncThunk(
  "members/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/members`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateMembersItem = createAsyncThunk(
  "members/updateItem",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(`${API_BASE}/api/members?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: body,
    });

    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateMembersPass = createAsyncThunk(
  "members/updatePass",
  async (data, { getState, rejectWithValue }, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },

        body: JSON.stringify(data),
      });
      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Failed to reset password");
      }

      return json;
    } catch (err) {
      return rejectWithValue(err.message || "Unexpected error");
    }
  }
);

export const addMemberItem = createAsyncThunk(
  "members/addItem",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(`${API_BASE}/api/members/register`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: body,
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const fetchMemberDetails = createAsyncThunk(
  "auth/fetchMemberDetails",
  async (userId, thunkAPI) => {
    try {
      const res = await fetch(
        `${API_BASE}/api/members/getByParam?_id=${userId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "partner",
          },
        }
      );
      // if (res.status === 401) {
      //   thunkAPI.dispatch(logoutUser());
      //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      //   return thunkAPI.rejectWithValue("Unauthorized");
      // }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Failed to fetch member details");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Fetch failed");
    }
  }
);



// GET /members/stripe - Fetch logged-in member's Stripe account
export const fetchStripeAccount = createAsyncThunk(
  "stripe/fetchAccount",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/members/stripe`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch Stripe account");
    }
    return json;
  }
);



export const createOrUpdateStripeAccount = createAsyncThunk(
  "stripe/createOrUpdate",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/members/stripe`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });
      const json = await res.json();

      // Handle non-OK responses
      if (!res.ok) {
        return thunkAPI.rejectWithValue(
          json?.message || "Failed to create/update Stripe account"
        );
      }

      return json;
    } catch (err) {
      // Catch network or unexpected errors
      return thunkAPI.rejectWithValue(err.message || "Network error");
    }
  }
);
